type EqualityFunction = <T = any>(a: T, b: T) => boolean;

const defaultIsEqual: EqualityFunction = (a, b) => a === b;

export const memes = <T extends (...args: any) => any>(fn: T, isEqual: EqualityFunction = defaultIsEqual): T => {
	let lastArgs: any[] = [];
	let lastResult: any;
	let calledOnce = false;

	const isNewArgEqualToLast = (newArg: any, index: number) => isEqual(newArg, lastArgs[index]);

	return function (...newArgs: any[]) {
		if (calledOnce && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
			return lastResult;
		}

		lastResult = fn(...newArgs);
		calledOnce = true;
		lastArgs = newArgs;

		return lastResult;
	} as any;
};

export default memes;
